var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-switch',{attrs:{"label":"Nadpisuj lokalizacje wypełnionego pola przy aktualizacji","input-value":_vm.options.overwriteFields},on:{"change":function($event){return _vm.update({overwriteFields: $event})}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }